import { categories } from '@/mocks/categories';

export default function Hero() {
  return (
    <section className="relative w-full min-h-[620px] md:min-h-[720px] flex items-center justify-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Abstract%20flowing%20silk%20ribbons%20in%20warm%20coral%20peach%20and%20soft%20mint%20green%20tones%20cascading%20through%20a%20bright%20airy%20space%20with%20gentle%20bokeh%20light%20particles%2C%20ethereal%20fashion%20concept%20background%2C%20dreamy%20editorial%20composition%2C%20soft%20focus%20atmosphere%20with%20golden%20hour%20warmth%20diffused%20through%20sheer%20fabric%20layers%2C%20sophisticated%20minimalist%20brand%20aesthetic&width=1600&height=900&seq=hero-superbuy-v2&orientation=landscape"
          alt="Superbuy Spreadsheet fashion shopping lifestyle background"
          title="Superbuy Spreadsheet shopping resource hub"
          className="w-full h-full object-cover object-top"
        />
      </div>
      <div className="absolute inset-0 bg-gradient-to-b from-black/35 via-black/20 to-black/40"></div>

      <div className="relative z-10 w-full px-4 md:px-6 text-center">
        <div className="max-w-3xl mx-auto">
          <span className="inline-block px-4 py-1.5 rounded-full bg-white/15 backdrop-blur-sm text-white/90 text-xs md:text-sm font-medium mb-5 md:mb-6 animate-fade-in">
            Independent Educational Resource &mdash; Updated 2026
          </span>

          <h1 className="font-heading text-3xl md:text-5xl lg:text-6xl text-white leading-tight mb-4 md:mb-6 animate-fade-in-up">
            Superbuy Spreadsheet: The Complete Guide, Templates &amp; Resources Hub
          </h1>

          <p className="text-white/80 text-sm md:text-lg max-w-2xl mx-auto mb-8 md:mb-10 leading-relaxed animate-fade-in-up animation-delay-200">
            Master Superbuy Spreadsheet with expert guides, comparison tables, templates, workflow tips, and security recommendations. Discover smarter ways to organize products, track prices, manage orders, and improve your online shopping workflow.
          </p>

          <div className="flex flex-col sm:flex-row items-center justify-center gap-4 mb-10 animate-fade-in-up animation-delay-400">
            <a
              href="https://kaspreadsheet.com"
              target="_blank"
              rel="noopener nofollow"
              className="w-full sm:w-auto inline-flex items-center justify-center px-8 py-3.5 rounded-full bg-primary-500 text-white font-semibold text-sm md:text-base hover:bg-primary-600 transition-all duration-300 whitespace-nowrap cursor-pointer shadow-lg shadow-primary-500/25"
            >
              superbuy sheet
              <i className="ri-arrow-right-up-line ml-2"></i>
            </a>
            <a
              href="https://kaspreadsheet.com"
              target="_blank"
              rel="noopener nofollow"
              className="w-full sm:w-auto inline-flex items-center justify-center px-8 py-3.5 rounded-full bg-white text-foreground-900 font-semibold text-sm md:text-base hover:bg-white/90 transition-all duration-300 whitespace-nowrap cursor-pointer"
            >
              buy it now
              <i className="ri-shopping-cart-line ml-2"></i>
            </a>
          </div>

          <div className="max-w-md mx-auto animate-fade-in-up animation-delay-600">
            <label htmlFor="category-select" className="block text-white/80 text-xs md:text-sm mb-2 text-left">
              Browse by Category
            </label>
            <div className="relative">
              <select
                id="category-select"
                defaultValue=""
                onChange={(e) => {
                  if (e.target.value) {
                    window.open(e.target.value, '_blank', 'noopener,nofollow');
                  }
                }}
                className="w-full appearance-none bg-white/15 backdrop-blur-sm border border-white/20 rounded-xl px-5 py-3.5 text-white text-sm cursor-pointer outline-none focus:border-white/40 transition-colors [&>option]:text-foreground-800 [&>option]:bg-white"
              >
                <option value="" disabled>Select a category to shop...</option>
                {categories.map((cat) => (
                  <option key={cat.name} value={cat.url}>
                    {cat.name}
                  </option>
                ))}
              </select>
              <div className="absolute right-4 top-1/2 -translate-y-1/2 pointer-events-none">
                <i className="ri-arrow-down-s-line text-white text-lg"></i>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}